import { IWindowService, element as ngElement } from 'angular';
import { Directive, Inject, Input, OnInit } from 'angular-ts-decorators';

@Directive({
  selector: '[productToolbarSticky]',
})
export class ProductToolbarStickyDirective implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$scope', '$element', '$window'];

  @Input('@') public productToolbarSticky?: string;
  @Input('@') public productToolbarContainer?: string;

  constructor(
    @Inject('$scope') private $scope: ng.IScope,
    @Inject('$element') private $element: JQLite,
    @Inject('$window') private $window: ng.IWindowService
  ) { }

  public ngOnInit(): void {
    const $win: JQuery<IWindowService> = ngElement(this.$window);

    const stickyCls: string = this.productToolbarSticky;
    const element: HTMLElement = this.$element[0];
    const $container: JQuery = ngElement(this.productToolbarContainer);

    const scroll: () => any = (): any => {
      if (element.offsetWidth === 0 && element.offsetHeight === 0) {
        this.$element
          .removeClass(stickyCls)
          .next('.sticky-phantom')
          .remove();
        return;
      }

      const isSticky: boolean = this.$element.hasClass(stickyCls);
      const initialOffsetTop = isSticky ? this.$element.next('.sticky-phantom').offset().top : this.$element.offset().top;

      if ($win.scrollTop() >= initialOffsetTop) {
        if ($win.scrollTop() > $container.offset().top + $container.height() - this.$element.height()) {
          this.$element.css('opacity', 0);
        } else {
          this.$element.css('opacity', 1);
        }

        if (this.$element.hasClass(stickyCls)) {
          return;
        }

        if (element.offsetHeight !== 0) {
          this.$element.after(`<div class="sticky-phantom" style="height: ${this.$element.outerHeight()}px;"></div>`);
        }

        this.$element.addClass(stickyCls);
      } else if (this.$element.hasClass(stickyCls)) {
        this.$element
          .removeClass(stickyCls)
          .next('.sticky-phantom')
          .remove();
      }
    };

    scroll();
    $win.on('scroll resize', scroll);

    this.$scope.$on('$destroy', (): void => {
      $win.off('scroll resize', scroll);
    });
  }
}
